/*
 * 🔒 The Possible duplicate question inside the upload window (decision 3014):
 * the two files side by side, each scrolling in its own viewer, and the two
 * answers beneath. A window too narrow for two draws one above the other.
 */
.question {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-3);
  border: var(--field-border-width) solid var(--border);
  border-radius: var(--radius-small);
  background: var(--surface-2);
}

.title {
  margin: 0;
  font-weight: var(--font-weight-semibold);
}

.text {
  margin: 0;
}

.hint {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-caption);
}

.pair {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(var(--possible-duplicate-side-min-width), 100%), 1fr));
  gap: var(--space-3);
}

.side {
  display: grid;
  align-content: start;
  gap: var(--space-1);
  min-width: 0;
}

.caption {
  margin: 0;
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  color: var(--text-muted);
}

/* The record, the type and the upload above the standing file, each a part of its own that wraps whole. */
.facts {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-3);
  margin: 0;
  font-size: var(--font-size-small);
  overflow-wrap: anywhere;
}

/* 🔒 Each file scrolls inside its own frame, so the two are compared page by page. */
.stage {
  height: var(--possible-duplicate-viewer-height);
  overflow: auto;
}

.picture {
  display: block;
  max-width: 100%;
}

.frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

.answers {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}
